import { trigger, style, animate, transition } from '@angular/animations';

export const AnimationHomepageSearchToggle = trigger('showSearchPanel', [
  transition(':enter', [
    style({ height: 0, overflow: 'hidden' }),
    animate('.5s ease-in-out', style({ height: '*' })),
    style({ overflow: 'visible' })
  ]),
  transition(':leave', [style({ height: '*', overflow: 'hidden' }), animate('.5s ease-in-out', style({ height: 0 }))])
]);
